import { getUrls } from '@shared/utils/config/environment';
import { ChainId } from '@shared/utils/config/networks';
export default function updateIndexerAssets({
  fromAssets,
  toAssets,
  PKP,
  queryClient,
  txHash
}) {
  var _a, _b;
  try {
    const fromAssetTokenAddress = fromAssets[0].contract_address;
    const fromAssetNetwork = fromAssets[0].network;
    const fromAssetWallet = fromAssetNetwork == ChainId.SOLANA ? PKP === null || PKP === void 0 ? void 0 : PKP.solanaAddress : (_a = PKP === null || PKP === void 0 ? void 0 : PKP.additionalEthAddress) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    const toAssetTokenAddress = toAssets[0].contract_address;
    const toAssetNetwork = toAssets[0].network;
    const toAssetWallet = toAssetNetwork == ChainId.SOLANA ? PKP === null || PKP === void 0 ? void 0 : PKP.solanaAddress : (_b = PKP === null || PKP === void 0 ? void 0 : PKP.additionalEthAddress) === null || _b === void 0 ? void 0 : _b.toLowerCase();
    const updateFromAssetUrl = `${getUrls().INDEXER_URL}/jobs/index-balance-for-token?chain=${fromAssetNetwork}&wallet=${fromAssetWallet}&token=${fromAssetTokenAddress}&tx_hash=${txHash}`;
    const updateToAssetUrl = `${getUrls().INDEXER_URL}/jobs/index-balance-for-token?chain=${toAssetNetwork}&wallet=${toAssetWallet}&token=${toAssetTokenAddress}&tx_hash=${txHash}`;
    const updateNativeFromAssetUrl = `${getUrls().INDEXER_URL}/jobs/index-balance-for-token?chain=${fromAssetNetwork}&wallet=${fromAssetWallet}&token=0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee&tx_hash=${txHash}`;
    const updateNativeToAssetUrl = `${getUrls().INDEXER_URL}/jobs/index-balance-for-token?chain=${toAssetNetwork}&wallet=${toAssetWallet}&token=0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee&tx_hash=${txHash}`;
    try {
      fetch(updateFromAssetUrl);
      fetch(updateToAssetUrl);
      fetch(updateNativeFromAssetUrl);
      fetch(updateNativeToAssetUrl);
    } catch (e) {
      console.log('[updateIndexerAssets] Executing order error updating asset balances', e);
    }
    setTimeout(() => {
      queryClient.invalidateQueries({
        queryKey: ['userbalance']
      });
    }, 2000);
  } catch (e) {
    console.error('[updateIndexerAssets] Error updating indexer assets', e);
  }
}